import './App.css';
import { Link, Routes, Route, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact/Contact';
import LOGO from './assets/logo2.png';
import Footer from './pages/Footer/Footer';
import OurServices from './pages/OurServices';
import ScrollToTop from './utils/ScrollTop';
import NotFound from './pages/NotFound';
import {  FloatButton } from 'antd';

const App = () => {
  const location = useLocation(); 

  const isActive = (path) => location.pathname === path;

  return (
    <div>
        <Navbar expand="lg" className='position-absolute w-100' style={{justifyContent:'space-between'}}>
        <Container style={{margin:0,maxWidth:'100%'}}>
          <Navbar.Brand>
            <Link to="/" className="navbar-brand d-flex align-items-center">
              <img src={LOGO} alt="Company Logo" width="80" height="80" className="me-2" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="bg-light" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto justify-content-end w-100">
              <Nav.Link as={Link} className={`text-uppercase ${isActive('/') ? 'active-link' : ''}`} to="/">Home</Nav.Link>
              <Nav.Link as={Link} className={`text-uppercase ${isActive('/about') ? 'active-link' : ''}`} to="/about">About us</Nav.Link>
              <Nav.Link as={Link} className={`text-uppercase ${isActive('/services') ? 'active-link' : ''}`} to="/services">SERVICES</Nav.Link>
              <Nav.Link as={Link} className={`text-uppercase ${isActive('/projects') ? 'active-link' : ''}`} to="/projects">PROJECTS</Nav.Link>
              <Nav.Link as={Link} className={`text-uppercase ${isActive('/contact') ? 'active-link' : ''}`} to="/contact">Get in touch</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <FloatButton.BackTop
      visibilityHeight={600} // The height after which the button appears
      style={{ right: 30, bottom: 30 }} // Positioning adjustments
    />
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/services' element={<OurServices />} />
        <Route path='/about' element={<About />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/contact' element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      
    </div>
  );
}

export default App;
